import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve Travel snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|journeyDayId|dayId|activityId|itineraryId|ownerMemberId|creatorMemberId|memberId|createdByMemberId|conversationId|locationId|id)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey planning (schedule / activities) — not public publication timeline. */
export const journeyPlanningApi = {
  getSchedule: (journeyId) => travelClient.get(
    travelEndpoints.journeySchedule(journeyId),
    snowflakeJson,
  ),
  createActivity: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyActivities(journeyId),
    body,
    snowflakeJson,
  ),
  getActivity: (journeyId, activityId) => travelClient.get(
    travelEndpoints.journeyActivity(journeyId, activityId),
    snowflakeJson,
  ),
  updateActivity: (journeyId, activityId, body) => travelClient.patch(
    travelEndpoints.journeyActivity(journeyId, activityId),
    body,
    snowflakeJson,
  ),
  removeActivity: (journeyId, activityId, expectedRowVersion) => travelClient.delete(
    travelEndpoints.journeyActivity(journeyId, activityId),
    { params: { expectedRowVersion }, ...snowflakeJson },
  ),
  moveActivity: (journeyId, activityId, body) => travelClient.post(
    travelEndpoints.journeyActivityMove(journeyId, activityId),
    body,
    snowflakeJson,
  ),
  /**
   * Activity execution (AUTH55). CAS uses itinerary rowVersion from schedule.itineraryRowVersion.
   * Commands are NOT idempotent — caller must not treat repeat-after-transition as success.
   */
  confirmActivity: (journeyId, activityId, { expectedRowVersion }) => travelClient.post(
    travelEndpoints.journeyActivityConfirm(journeyId, activityId),
    { expectedRowVersion },
    snowflakeJson,
  ),
  startActivity: (journeyId, activityId, { expectedRowVersion }) => travelClient.post(
    travelEndpoints.journeyActivityStart(journeyId, activityId),
    { expectedRowVersion },
    snowflakeJson,
  ),
  completeActivity: (journeyId, activityId, { expectedRowVersion }) => travelClient.post(
    travelEndpoints.journeyActivityComplete(journeyId, activityId),
    { expectedRowVersion },
    snowflakeJson,
  ),
  cancelActivity: (journeyId, activityId, { expectedRowVersion, cancellationReason = null } = {}) => travelClient.post(
    travelEndpoints.journeyActivityCancel(journeyId, activityId),
    { expectedRowVersion, cancellationReason },
    snowflakeJson,
  ),
  shareActivityToChat: (journeyId, activityId, body = { confirm: true }) => travelClient.post(
    travelEndpoints.journeyActivityChatShare(journeyId, activityId),
    body,
    snowflakeJson,
  ),
};
